<template>
  <v-row v-if="!!content.scenario && content.items.length > 0" justify="center" no-gutters
         style="user-select: none;">
    <v-window v-model="currentStep">
      <v-window-item style="min-height: 454px;" value="1">
        <div style="max-width: 900px;">
          <v-row align="center" class="mb-6" no-gutters>
            <div class="white--text display-2 font-weight-thin">Scenario</div>
          </v-row>
          <div class="white--text text-justify" style="font-size: 18px;" v-html="content.scenario"></div>
          <v-row class="mt-4" justify="end" no-gutters>
            <v-btn color="#2A72A1"
                   dark
                   class="rounded-lg"
                   large
                   @click="next()"
            >Continue
            </v-btn>
          </v-row>
        </div>
      </v-window-item>
      <v-window-item v-for="(item,index) in content.items"
                     :key="index"
                     :value="index+2"
                     style="min-height: 454px;"
      >
        <div v-if="questionDisplay" style="max-width: 900px;">
          <v-row align="center" class="mb-6" no-gutters>
            <div class="white--text display-2 font-weight-thin">{{ item.question }}</div>
          </v-row>
          <div class="subtitle-1 white--text mb-6" v-html="item.subtitle"></div>
          <v-card
              class="mb-4 rounded-lg"
              elevation="4"
              hover
              :key="index"
              :color="opt.id === item.answer ? '#285780' : ''"
              :dark="opt.id === item.answer"
              v-for="(opt,index) in item.options"
              @click.stop="setAnswer(item, opt)"
          >
            <v-card-text :class="opt.id === item.answer ? 'white--text' : 'black--text'">
              {{ opt.text }}
            </v-card-text>
          </v-card>
          <v-row class="mt-6" justify="end" no-gutters>
            <v-btn :disabled="item.answer===null"
                   color="#2A72A1"
                   dark
                   class="rounded-lg"
                   large
                   @click="saveAnswer()"
            >Continue
            </v-btn>
          </v-row>
        </div>
        <div v-else class="text-xs-center">
          <slw-chart v-if="!questionDisplay && result"
                     :id="index+'_container'"
                     :initState="result"
                     :prevState="prevResult"
                     :axis="axisLabels"
          >
          </slw-chart>
          <v-row justify="center" no-gutters style="transform: translateY(-50px)">
            <v-btn v-if="currentStep <= content.items.length"
                   color="#2A72A1"
                   dark
                   class="rounded-lg"
                   large
                   @click="next()"
            >Continue
            </v-btn>
            <v-btn v-if="currentStep === content.items.length + 1"
                   color="#2A72A1"
                   dark
                   class="rounded-lg"
                   large
                   @click="currentStep = content.items.length + 2"
            >Continue
            </v-btn>
          </v-row>
        </div>
      </v-window-item>
      <v-window-item :value="content.items.length + 2">
        <v-row align="center" class="fill-height" justify="center" no-gutters style="min-height: 454px;">
          <v-col cols="12">
            <div class="display-2 font-weight-thin white--text">
              Thank you for participating!
            </div>
            <v-row class="mt-10" justify="center" no-gutters>
              <v-btn color="#2A72A1" class="rounded-lg" dark large @click="restart()">Continue</v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-window-item>
    </v-window>
  </v-row>
</template>
<style>

</style>
<script>
import SlwChart from "@/components/PwcLeadershipGame/SlwChart";

export default {
  props: {
    reset: {
      type: Boolean,
      default: false
    }
  },
  components: {SlwChart},
  data() {
    return {
      content: {
        scenario: null,
        items: []
      },
      currentStep: 1,
      questionDisplay: true,
      outOfTime: false,
      time: 0,
      interval: null,
      axisLabels: [],
    }
  },
  computed: {
    itemsWithCurrent() {
      if (this.currentStep - 1 > 0) {
        return this.content.items.slice(0, this.currentStep - 1);
      } else {
        return null;
      }
    },
    prevItems() {
      if (this.currentStep - 2 > 0) {
        return this.content.items.slice(0, this.currentStep - 2);
      } else {
        return null;
      }
    },
    result() {
      return this.getResult(this.itemsWithCurrent);
    },
    prevResult() {
      return this.getResult(this.prevItems);
    }
  },
  created() {
    this.initContent();
  },
  methods: {
    importData() {
      if (this.$route.params.app === 'pwc-tdc-toolkit') {
        const content = require('@/assets/text/pwc_leadership_game.json');
        this.$set(this.content, 'scenario', content.scenario);
        this.$set(this, 'time', content.time);
        this.$set(this.content, 'items', require('@/assets/questions/questions_tdc.json'));
      } else if (this.$route.params.app === 'meridian-tdc-toolkit') {
        const content = require('@/assets/text/meridian_leadership_game.json')
        this.$set(this.content, 'scenario', content.scenario);
        this.$set(this, 'time', content.time);
        this.$set(this.content, 'items', require('@/assets/questions/questions_meridian.json'));
      } else if (this.$route.params.app === 'fitt-accreditation-training') {
        const content = require('@/assets/text/the_fitt_decision_game.json')
        this.$set(this.content, 'scenario', content.scenario);
        this.$set(this, 'time', content.time);
        this.$set(this.content, 'items', require('@/assets/questions/questions_fat.json'));
      } else if (this.$route.params.app === 'gulf-health-council-tdc-toolkit') {
        const content = require('@/assets/text/ghc_leadership_game.json')
        this.$set(this.content, 'scenario', content.scenario);
        this.$set(this, 'time', content.time);
        this.$set(this.content, 'items', require('@/assets/questions/questions_ghc.json'));
      } else if (this.$route.params.app === 'medihelp-tdc-toolkit') {
        const content = require('@/assets/text/medihelp_leadership_game.json')
        this.$set(this.content, 'scenario', content.scenario);
        this.$set(this, 'time', content.time);
        this.$set(this.content, 'items', require('@/assets/questions/questions_medihelp.json'));
      } else if (this.$route.params.app === 'eskom-tdc-toolkit' || this.$route.params.app === 'armscor-tdc-toolkit') {
        const content = require('@/assets/text/eskom_leadership_game.json')
        this.$set(this.content, 'scenario', content.scenario);
        this.$set(this, 'time', content.time);
        this.$set(this.content, 'items', require('@/assets/questions/questions_eskom.json'));
      } else if (this.$route.params.app === 'peak-activities' || this.$route.params.app === 'nomac-pdp-workshop') {
        const content = require('@/assets/text/peak_leadership_game.json')
        this.$set(this.content, 'scenario', content.scenario);
        this.$set(this, 'time', content.time);
        this.$set(this.content, 'items', require('@/assets/questions/questions_peak.json'));
        this.$set(this, 'axisLabels', content.axis_labels);
      }
    },
    setTimeBasedOnApp() {
      if (this.$route.params.app === 'pwc-tdc-toolkit') {
        this.$set(this, 'time', require('@/assets/text/pwc_leadership_game.json').time);
      } else if (this.$route.params.app === 'fitt-accreditation-training') {
        this.$set(this, 'time', require('@/assets/text/the_fitt_decision_game.json').time);
      } else if (this.$route.params.app === 'meridian-tdc-toolkit') {
        this.$set(this, 'time', require('@/assets/text/meridian_leadership_game.json').time);
      } else if (this.$route.params.app === 'gulf-health-council-tdc-toolkit') {
        this.$set(this, 'time', require('@/assets/text/ghc_leadership_game.json').time);
      } else if (this.$route.params.app === 'medihelp-tdc-toolkit') {
        this.$set(this, 'time', require('@/assets/text/medihelp_leadership_game.json').time);
      } else if (this.$route.params.app === 'eskom-tdc-toolkit' || this.$route.params.app === 'armscor-tdc-toolkit') {
        this.$set(this, 'time', require('@/assets/text/eskom_leadership_game.json').time);
      } else if (this.$route.params.app === 'peak-activities' || this.$route.params.app === 'nomac-pdp-workshop') {
        this.$set(this, 'time', require('@/assets/text/peak_leadership_game.json').time);
      }
    },
    restart() {
      this.$emit('time', null);
      clearInterval(this.interval);
      this.interval = null;
      this.outOfTime = false;
      this.currentStep = 1;
      this.initContent();
    },
    continueTool() {
      clearInterval(this.interval);
      this.interval = null;
      this.setTimeBasedOnApp();
      this.startTimer();
      this.outOfTime = false;
    },
    next() {
      clearInterval(this.interval);
      this.setTimeBasedOnApp();
      if (this.currentStep > 1 || this.currentStep < this.content.items.length + 2) {
        this.startTimer();
      }
      this.questionDisplay = true;
      this.currentStep++;
    },
    saveAnswer() {
      this.questionDisplay = false;
      this.pauseTimer();
    },
    initContent() {
      this.content.items.forEach((question) => {
        this.$set(question, 'answer', null);
        this.$set(question, 'reflection', null);
      })
      this.$forceUpdate();
    },
    findOptionById(question, id) {
      for (let ans of question.options) {
        if (ans.id === id)
          return ans;
      }
      return null;
    },
    updateResultWithAnswer(result, answer) {
      if (result.s === null) {
        for (let key in result) {
          result[key] = answer[key];
        }
      } else {
        for (let key in result) {
          result[key] += answer[key];
        }
      }
    },
    getResult(items) {
      if (items === null)
        return null;
      const res = {
        s: null,
        o: null,
        p: null,
        t: null,
      };
      let c = 0;
      let n = 0;
      for (let question of items) {
        c++;
        if (question.answer !== null) {
          const opt = this.findOptionById(question, question.answer);
          this.updateResultWithAnswer(res, opt, c);
          n++;
        }
      }
      if (res.s === null)
        return null;
      for (let key in res) {
        res[key] = res[key] / n;
      }
      return res;
    },
    startTimer() {
      this.interval = setInterval(() => {
        this.time -= 1000;
        let min = Math.floor(this.time / (60 * 1000)),
            sec = Math.floor((this.time - (min * 60 * 1000)) / 1000);
        if (this.time <= 0) {
          // this.time = content.time;
          this.$emit('time', 'Out of Time');
          // clearInterval(this.interval);
          // this.outOfTime = true;
        } else {
          this.$emit('time', `${min >= 10 ? min : '0' + min}:${sec >= 10 ? sec : '0' + sec}`);
        }
      }, 1000);
    },
    pauseTimer() {
      clearInterval(this.interval);
    },
    setAnswer(item, opt) {
      this.$set(item, 'answer', opt.id);
    },
  },
  mounted() {
    this.importData();
  },
  watch: {
    currentStep(val) {
      if (val === 1) {
        this.$emit('time', null);
      } else if (this.currentStep === this.content.items.length + 2) {
        clearInterval(this.interval);
        this.$emit('time', null);
      }
    }
  }
}
</script>

